import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
interface FinalCtaSectionProps {
  onCtaClick: (label: string) => void; // CTAクリックの関数を受け取る
}

export default function FinalCtaSection({ onCtaClick }: FinalCtaSectionProps) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="contact" className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="./images/final-cta-bg.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-clinic-green-dark/80" />
      </div>

      <div ref={ref} className={`relative z-10 w-full px-4 md:px-8 text-center text-white max-w-3xl mx-auto scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <h2 className="font-serif text-xl md:text-3xl font-bold mb-4 leading-relaxed scroll-reveal-item delay-1">
          もう、一人で頑張らなくていいんですよ
        </h2>
        <p className="text-sm md:text-base leading-relaxed opacity-90 mb-8 scroll-reveal-item delay-2">
          毎日、辛い症状を我慢して頑張っているあなた。
          <br className="hidden md:block" />
          その辛さを手放して、元通りの「元気な私」に戻りませんか？
          <br />
          私たちが全力でサポートします。まずはLINEから、今の悩みをご相談ください。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 scroll-reveal-item delay-3">
          <a
            href="https://lin.ee/yWTagrY"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => onCtaClick('FinalCtaSection_LINE')}
            className="inline-flex items-center gap-2 bg-clinic-line text-white font-bold text-base md:text-lg px-8 py-4 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
          >
            <i className="ri-line-fill text-xl" />
            LINEで予約・相談する
          </a>
          <a
            href="tel:0297-45-9659"
            onClick={() => onCtaClick('FinalCtaSection_Tel')}
            className="inline-flex items-center gap-2 bg-white text-clinic-green-dark font-bold text-base md:text-lg px-8 py-4 rounded-full hover:bg-white/90 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-fill text-xl" />
            今すぐ電話で予約する
          </a>
        </div>
      </div>
    </section>
  );
}